var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34F3C692-F957-4330-98ED-954006F424D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share-Modal",
    transform: "translate(-1027.000000, -451.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(682.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(345.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pinterest"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CB2027",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1740322,53.264712 C40.2006173,53.0293073 38.9512361,51.5199902 36.6193385,50.0709597 C35.3377062,56.954393 33.7714225,63.5529006 29.1321661,67 C27.6983926,56.5962622 31.2340991,48.7819756 32.8761028,40.4875497 C30.0772647,35.6646249 33.2126365,25.9570533 39.1159974,28.3491379 C46.3816184,31.2902608 32.8256228,46.2822365 41.9260533,48.1547083 C51.4268186,50.1097154 55.3053688,31.2794953 49.4132256,25.1546679 C40.9003268,16.3119213 24.6338331,24.9537127 26.6341049,37.6124549 C27.1213776,40.707165 30.2455316,41.6466306 27.8820838,45.9169286 C22.4337445,44.6817718 20.8085674,40.283006 21.0174987,34.4187026 C21.3547335,24.8195033 29.4434597,18.0982695 37.5567249,17.168134 C47.8174953,15.9925461 57.4479663,21.0250385 58.7772741,30.9048574 C60.2727455,42.055718 54.1450288,54.1316902 43.1740322,53.264712 L43.1740322,53.264712 Z",
    id: "Path",
    fill: "#F1F2F2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.9a26fc7de6b1d9c9db9e48a053bf55dc.svg";
export { ForwardRef as ReactComponent };